import { useEffect, useState } from "react";

function formatVersionLabel(meta) {
  const version = typeof meta?.version === "string" ? meta.version.trim() : "";
  const build = Number.isInteger(meta?.buildNumber) ? meta.buildNumber : null;

  if (version && build !== null) return `v${version} (${build})`;
  if (version) return `v${version}`;
  return "vunknown";
}

export function useAppVersion() {
  const [label, setLabel] = useState("vunknown");

  useEffect(() => {
    let mounted = true;

    fetch("/release-version.json", { cache: "no-store" })
      .then((res) => (res.ok ? res.json() : null))
      .then((meta) => {
        if (!mounted || !meta) return;
        setLabel(formatVersionLabel(meta));
      })
      .catch(() => {
        // Keep fallback label when version metadata is unavailable.
      });

    return () => {
      mounted = false;
    };
  }, []);

  return label;
}
